// extracted by mini-css-extract-plugin
export default {"ingredient":"primary-ingredient_ingredient__Rx5Gd","ingredient_invisible":"primary-ingredient_ingredient_invisible__ER5yv"};